export default "__VITE_ASSET__C7P_x1PL__"